export const fmtDate = (iso: string) => {
  const [y, m, d] = iso.slice(0, 10).split("-");
  return `${d}/${m}/${y}`;
};

// A cost whose own period lies wholly within the settlement period: only
// those are ticked by default (decision 1, 2026-10-20).
export const withinPeriod = (
  inv: { periodFrom: string; periodTo: string },
  period: { from: string; to: string },
) =>
  inv.periodFrom.slice(0, 10) >= period.from &&
  inv.periodTo.slice(0, 10) <= period.to;

export const overlapsPeriod = (
  inv: { periodFrom: string; periodTo: string },
  period: { from: string; to: string },
) => !(inv.periodTo < period.from || inv.periodFrom > period.to);

// The part of the settlement period a tenant rented, for under their name: a
// tenant who moved in on 1 April is not settled from 1 January. Without
// contract dates (or without overlap) it is the settlement period itself.
export const rentedPeriodLabel = (
  period: { from: string; to: string },
  contract?: { from: string; to: string },
): string => {
  const periodFrom = period.from.slice(0, 10);
  const periodTo = period.to.slice(0, 10);
  const contractFrom = contract?.from.slice(0, 10);
  const contractTo = contract?.to.slice(0, 10);
  const from =
    contractFrom && contractFrom > periodFrom ? contractFrom : periodFrom;
  const to = contractTo && contractTo < periodTo ? contractTo : periodTo;
  return from <= to
    ? `${fmtDate(from)} → ${fmtDate(to)}`
    : `${fmtDate(periodFrom)} → ${fmtDate(periodTo)}`;
};
